<template>
  <!-- Index Page for Staff Update (Daily Attendance) -->
  <div class="row justify-content-center">
    <div class="col-sm-12 col-md-6">
      <div class="card">
        <div class="card-body">
          <a-form>
            <div class="row">
              <div class="col-12">
                <a-form-item label="Select Date">
                  <a-date-picker v-model="date" style="width: 100%" :disabled-date="disabledDate"></a-date-picker>
                </a-form-item>
              </div>
              <a-divider style="margin:15px 0px 5px 0px;" />
              <div class="col" style="text-align: right; padding:15px 0px;">
                <a-button
                  type="primary"
                  @click="buttonHandler"
                  :disabled="btnState.viewFrozen"
                >
                  Update Attendance
                </a-button>
              </div>
            </div>
          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'UpdateDailyAttendanceIndex',
  data() {
    return {
      date: moment(),
      btnState: { viewFrozen: false },
    }
  },
  watch: {
    date(val) {
      this.btnState.viewFrozen = val === null
    },
  },
  methods: {
    moment,
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    buttonHandler() {
      if (this.date) {
        const day = moment(this.date).format('YYYY-MM-DD')
        this.$router.push({ name: 'updatestaffattendancedaily', params: { day } })
      }
    },
  },
}
</script>
